import React, { useState, useEffect, useRef } from "react";
import TextField from "@mui/material/TextField";
import "./classes/PayOrder.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrash, faShoppingBasket } from "@fortawesome/free-solid-svg-icons";
import { Helmet } from "react-helmet";
import { useReactToPrint } from "react-to-print";

const PayOrder = () => {
  const products = [
    { id: 1, name: "turmeric powder", price: 5, barcode: "10001", stock: 150 },
    { id: 2, name: "amla juice", price: 6, barcode: "10002", stock: 84 },
    { id: 3, name: "mixed fruits", price: 7, barcode: "10003", stock: 100 },
    { id: 4, name: "bath soap", price: 8, barcode: "10004", stock: 120 },
    { id: 5, name: "toothpaste", price: 4, barcode: "10005", stock: 180 }
  ];

  /* ---------------- STATE ---------------- */
  const [searchValue, setSearchValue] = useState("");
  const [barcodeValue, setBarcodeValue] = useState("");
  const [cart, setCart] = useState([]);
  const [cashPaid, setCashPaid] = useState(0);
  const [isModalOpen, setIsModalOpen] = useState(false);

//   const componentRef = useRef(null);
//   const handlePrint = useReactToPrint({
//     content: () => componentRef.current,
//     documentTitle: "Receipt"
//   });
    const contentRef = useRef(null);
//   const reactToPrintFn = useReactToPrint({
//     content: () => contentRef.current,
//   });

  const handlePrint = useReactToPrint({
    contentRef: contentRef,
    documentTitle: "Receipt",
  });

  /* ---------------- PRODUCT FILTER (NAME ONLY) ---------------- */
  const filteredProducts = products.filter(p =>
    p.name.toLowerCase().includes(searchValue.toLowerCase())
  );

  /* ---------------- BARCODE SCAN (ONLY ADD TO CART) ---------------- */
  useEffect(() => {
    if (!barcodeValue) return;

    if (/^\d+$/.test(barcodeValue)) {
      const product = products.find(p => p.barcode === barcodeValue);
      if (product) {
        addToCart(product);
        setBarcodeValue("");
      }
    }
  }, [barcodeValue, products]);

  /* ---------------- ADD TO CART ---------------- */
  const addToCart = product => {
    setCart(prev => {
      const found = prev.find(p => p.id === product.id);
      if (found) {
        return prev.map(p =>
          p.id === product.id
            ? { ...p, qty: p.qty + 1, total: (p.qty + 1) * p.price }
            : p
        );
      }
      return [...prev, { ...product, qty: 1, total: product.price }];
    });
  };

  /* ---------------- REMOVE ITEM ---------------- */
  const removeItem = id => {
    setCart(prev => prev.filter(p => p.id !== id));
  };

  /* ---------------- TOTALS ---------------- */
  const total = cart.reduce((s, i) => s + i.total, 0);
  const change =
    cashPaid >= total ? (cashPaid - total).toFixed(2) : "0.00";

  /* ---------------- ACTIONS ---------------- */
  const handleCancel = () => {
    setSearchValue("");
    setBarcodeValue("");
    setCart([]);
    setCashPaid(0);
  };

  const handleNewSale = () => {
    setCart([]);
    setCashPaid(0);
    setIsModalOpen(false);
  };
 

  return (
    <div className="pos-main">
      <Helmet>
        <title>Pay Order</title>
      </Helmet>

      <div className="pos-body">
        {/* LEFT PANEL */}
        <div className="pos-left">
            <div className="pos-flex">
                <TextField
                    value={searchValue}
                    onChange={e => setSearchValue(e.target.value)}
                    placeholder="Search product"
                    fullWidth
                    className="pos-flex-1"
                />

                <input
                    className="barcode-input pos-flex-2"
                    value={barcodeValue}
                    onChange={e => setBarcodeValue(e.target.value)}
                    autoFocus
                    placeholder="Scan barcode"
                />
            </div>
          <div className="product-grid">
            {filteredProducts.map(p => (
              <div
                key={p.id}
                className="product-card"
                onClick={() => addToCart(p)}
              >
                <h4>{p.name}</h4>
                <small>{p.barcode}</small>
                <div className="product-footer">
                  <span>Stock: {p.stock}</span>
                  <span>₹{p.price}</span>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* RIGHT PANEL */}
        <div className="pos-right">
            <div className="pos-right-heading">
                <div>
                    <FontAwesomeIcon className="pos-right-heading-icon" icon={faShoppingBasket} /><h3>Current Order</h3>
                </div>
                <span onClick={handleCancel} style={{color: "red", lineHeight: "3.6", marginRight:"5px"}}>CLEAR</span>
            </div>

          {cart.length === 0 ? (
            <p className="empty-cart">Start scanning...</p>
          ) : (
            cart.map(item => (
              <div className="order-item" key={item.id}>
                <div>
                  {item.name} × {item.qty}
                </div>
                <div>
                <span>
                  ₹{item.total}
                  </span>&nbsp;&nbsp;
                  <span style={{marginRight:"5px"}}>
                  <FontAwesomeIcon
                    icon={faTrash}
                    className="delete"
                    onClick={() => removeItem(item.id)}
                  />
                  </span>
                </div>
              </div>
            ))
          )}

          <div className="payment">
            <h2>Total: ₹{total.toFixed(2)}</h2>

            <input
              className="cash-input"
              value={cashPaid}
              onChange={e => setCashPaid(Number(e.target.value) || 0)}
              placeholder="Cash given"
            />

            <div className="quick-cash">
              <button onClick={() => setCashPaid(5)}>€5</button>
              <button onClick={() => setCashPaid(10)}>€10</button>
              <button onClick={() => setCashPaid(20)}>€20</button>
              <button onClick={() => setCashPaid(50)}>€50</button>
            </div>

            <h4>Change: €{change}</h4>

            <div className="actions">
              <button className="cancel" onClick={handleCancel}>
                Cancel
              </button>
              <button
                className="pay"
                disabled={cart.length === 0}
                onClick={() => {
                    if (cashPaid < total) {
                        alert("Low amount");
                        return;
                    }
                    setIsModalOpen(true)}}
                >
                PAY NOW
              </button>
            </div>
          </div>
        </div>
      </div>

      
  {isModalOpen && (
  <div className="modal-overlay">
    <div className="modal-box">
      <div className="success-icon">✓</div>

      <h2>Payment Successful!</h2>

      <div className="summary">
        <div>
          <span>Total:</span>
          <span>€{total.toFixed(2)}</span>
        </div>
        <div>
          <span>Paid:</span>
          <span>€{cashPaid.toFixed(2)}</span>
        </div>
        <div className="change">
          <span>CHANGE</span>
          <span>€{change}</span>
        </div>
      </div>

      <div className="modal-actions">
        <button className="dark" onClick={handlePrint}>
          Print Receipt
        </button>
        <button className="primary" onClick={handleNewSale}>
          New Sale
        </button>
      </div>
    </div>
  </div>
)}
<div ref={contentRef} className="printContent">
  <div className="receipt">
    <h2 className="shop-name">MY SHOP</h2>

    <div className="meta">
      <div>Date: {new Date().toLocaleString()}</div>
      <div>No: {Date.now()}</div>
    </div>

    <hr />

    <table className="items">
      <thead>
        <tr>
          <th>Qty</th>
          <th>Item</th>
          <th className="right">Price</th>
        </tr>
      </thead>
      <tbody>
        {cart.map(item => (
          <tr key={item.id}>
            <td>{item.qty}</td>
            <td>{item.name}</td>
            <td className="right">€{item.total.toFixed(2)}</td>
          </tr>
        ))}
      </tbody>
    </table>

    <hr />

    <div className="totals">
      {/* <div><span>Net:</span><span>€{(total - 2.9).toFixed(2)}</span></div>
      <div><span>GST:</span><span>€2.90</span></div> */}
      <div className="bold"><span>TOTAL:</span><span>€{total.toFixed(2)}</span></div>
      <div><span>CASH:</span><span>€{cashPaid.toFixed(2)}</span></div>
      <div><span>CHANGE:</span><span>€{change}</span></div>
    </div>

    <p className="thanks">*** THANK YOU ***</p>
  </div>
</div>


    </div>
  );
};

export default PayOrder;
